import { AgGridReact, AgGridReactProps } from '@ag-grid-community/react';
import { Flex } from '@chakra-ui/react';
import { LegacyRef } from 'react';

export const Grid = function <TData = unknown>(props: AgGridReactProps<TData> & { gridRef?: LegacyRef<AgGridReact<TData>> }) {
    const { gridRef, ...rest } = props;
    return (
        <Flex
            flexDirection="column"
            className="ag-theme-quartz"
            css={{
                '--ag-background-color': { _dark: 'colors.musa.dark.500' },
                '--ag-header-background-color': { _dark: 'colors.musa.dark.500' },
                '--ag-foreground-color': { _dark: 'musa.dark.label' },
                '--ag-header-foreground-color': { _dark: 'musa.dark.label' },
                '--ag-border-color': { _dark: 'colors.musa.dark.border' },
            }}
            h="100%">
            <AgGridReact {...rest} ref={gridRef} />
        </Flex>
    );
};
